(() => {
  const root = document.querySelector('[data-mon-newsletter]');
  if (!root) return;

  const dialog = root.querySelector('[data-mon-newsletter-dialog]');
  if (!(dialog instanceof HTMLDialogElement)) return;

  const closeButton = root.querySelector('[data-mon-newsletter-close]');
  const response = root.querySelector('[data-mon-newsletter-response]');
  const submitButton = root.querySelector('[data-mon-newsletter-submit]');
  const copyButton = root.querySelector('[data-mon-newsletter-copy]');
  const copyLabel = root.querySelector('[data-mon-newsletter-copy-label]');
  const dismissedKey = 'mon-newsletter-dismissed-v1';
  const subscribedKey = 'mon-newsletter-subscribed-v1';
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  let previousFocus = null;

  const readStorage = (key) => {
    try { return localStorage.getItem(key); } catch { return null; }
  };
  const writeStorage = (key, value) => {
    try { localStorage.setItem(key, value); } catch { /* Storage may be unavailable. */ }
  };
  const isVisible = (element) => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';

  function openDialog() {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    const activeElement = document.activeElement;
    dialog.show();
    if (activeElement instanceof HTMLElement && activeElement !== document.body) activeElement.focus({ preventScroll: true });
    else dialog.blur();
  }

  closeButton?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (response?.dataset.monNewsletterResponse !== 'success') writeStorage(dismissedKey, String(Date.now()));
    if (document.activeElement === document.body && previousFocus instanceof HTMLElement && previousFocus !== document.body) previousFocus.focus({ preventScroll: true });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && dialog.open && !document.querySelector('dialog[open]:not([data-mon-newsletter-dialog])')) {
      dialog.close();
    }
  });

  root.querySelector('form')?.addEventListener('submit', () => {
    if (!submitButton) return;
    submitButton.disabled = true;
    submitButton.textContent = 'Inscription en cours…';
  });

  copyButton?.addEventListener('click', async () => {
    const code = copyButton.dataset.code;
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      if (copyLabel) copyLabel.textContent = 'Copié';
      window.setTimeout(() => { if (copyLabel) copyLabel.textContent = 'Copier'; }, 2000);
    } catch {
      if (copyLabel) copyLabel.textContent = 'À saisir au paiement';
    }
  });

  if (response?.dataset.monNewsletterResponse === 'success') {
    writeStorage(subscribedKey, '1');
    openDialog();
    return;
  }
  if (response) {
    openDialog();
    return;
  }

  if (readStorage(subscribedKey) === '1') return;
  const dismissedAt = Number(readStorage(dismissedKey));
  if (dismissedAt && Date.now() - dismissedAt < sevenDays) return;

  /* 5 octobre 2026 : la fenêtre ne s'ouvre qu'une fois la moitié de la page
     parcourue, jamais avant le délai réglé, et jamais dans les 20 s qui
     suivent le choix cookies (deux fenêtres d'affilée masquaient le héros). */
  const delay = Math.max(Number(root.dataset.delay) || 8000, 0);
  const cookieGrace = 20000;
  const startedAt = Date.now();
  let cookieBannerSeen = false;
  let cookieClearedAt = null;
  let scrolledEnough = false;
  let timer = null;

  const scrollRatio = () => {
    let best = 0;
    [document.scrollingElement, document.querySelector('.page-wrapper')].forEach((el) => {
      if (!el) return;
      const max = el.scrollHeight - el.clientHeight;
      if (max > 0) best = Math.max(best, el.scrollTop / max);
    });
    return best;
  };

  function schedule(wait) {
    window.clearTimeout(timer);
    timer = window.setTimeout(tryOpen, wait);
  }

  function tryOpen() {
    if (dialog.open) return;
    const cookieBanner = document.getElementById('shopify-pc__banner');
    const cookiePrefs = document.getElementById('shopify-pc__prefs__dialog');
    const otherDialog = document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]');
    const cookieOpen = isVisible(cookieBanner) || isVisible(cookiePrefs);
    if (cookieOpen) {
      cookieBannerSeen = true;
      cookieClearedAt = null;
    }
    if (document.visibilityState !== 'visible' || cookieOpen || isVisible(otherDialog)) {
      schedule(2500);
      return;
    }
    if (cookieBannerSeen && cookieClearedAt === null) cookieClearedAt = Date.now();
    const wait = Math.max(
      startedAt + delay - Date.now(),
      cookieClearedAt === null ? 0 : cookieClearedAt + cookieGrace - Date.now()
    );
    if (wait > 0) {
      schedule(wait);
      return;
    }
    if (scrolledEnough) openDialog();
  }

  function onScroll() {
    if (scrolledEnough || scrollRatio() < 0.5) return;
    scrolledEnough = true;
    document.removeEventListener('scroll', onScroll, { capture: true });
    tryOpen();
  }

  /* Capture : le défilement se fait dans .page-wrapper sur ordinateur et
     dans le document sur téléphone, et l'évènement ne remonte pas. */
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  tryOpen();
})();
